<template>
    <div>
        <div class="card mb-3">
            <div class="card-header">アカウント管理</div>
            <div class="card-body">
                <user-account-primary/>
            </div>
        </div>

        <div
            v-if="$locale.type === 'consul'"
            class="card mb-5">
            <div class="card-header">外部アカウント連携</div>
            <div class="card-body">
                <user-account-social/>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'

    export default {
        created: function () {
            this.fetchMe()
            bus.$on('updated-user-account-email', this.fetchMe)
            bus.$on('detached-user-social-account', this.fetchMe)
        },

        mounted: function () {
            // メールアドレス認証結果のアラート
            if (this.$route.query.verified === '1') {
                bus.$emit('alert-success', 'メールアドレスを認証しました。')
            } else if (this.$route.query.verified === '0') {
                bus.$emit('alert-danger', '無効なリクエストです。')
            } else if (this.$route.query.expired === '1') {
                bus.$emit('alert-danger', '有効期限が切れています。')
            }
        },

        methods: {
            /**
             * ログインユーザ取得
             */
            fetchMe: function () {
                return axios.get(constants.user.me.endpoint.base)
                    .then(({data}) => {
                        bus.$emit('fetched-user-account', data.data)
                    })
            },
        },
    }
</script>
